import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'vds-teaser-grid',
  styleUrl: 'vds-teaser-grid.scss',
  shadow: true,
})
export class VdsTeaserGrid {

  /**
   * Headline for the Content Modules
   * Mandatory: no
   * Max Chars: 50
   */
  @Prop() headline: string;

  /**
   * Subline for the Content Module
   * Mandatory: no
   * Max Chars: 150
   */
  @Prop() subline: string;

  /**
   * Sets the grid columns for desktop
   * min: 2, max: 3
   */
  @Prop() cols: number = 3;

  /**
   * Set this to true if you want to use your own grid styles.
   * This will remove included styles for the grid.
   */
  @Prop({ reflect: true }) customStyles: boolean = false;

  render() {
    const { headline, subline, cols, customStyles } = this;
    return (
      <Host>
        <h2 class="font-heavy text-h2-mobile sm:text-h2-tablet lg:text-h2-desktop text-grey uppercase">{headline}</h2>
        <h3 class="font-regular text-s2-mobile sm:text-s2-tablet lg:text-s2-desktop text-berry uppercase mt-2">{subline}</h3>
        <div class={{
          "pt-6": customStyles,
          "sm:columns-2 columns-1 gap-x-6 pt-3": !customStyles,
          "md:columns-2": !customStyles && cols < 3,
          "md:columns-3": !customStyles && cols >= 3
        }}>
          <slot name="items"></slot>
        </div>
      </Host>
    );
  }

}
